import auth from './auth'
import product from './product'
import user from './user'
import shop from './shop'
import basis from './basis'
import member from './member'
import system from './system'
import stall from './stall'
import sale from './sale'
import payment from './payment'
import statistics from './statistics'
import weixin from './weixin'
import marketing from './marketing'
import merchant from './merchant'
import property from './property'
import passengerFlow from './passengerFlow'

export default {
  ...auth,
  ...product,
  ...user,
  ...shop,
  ...basis,
  ...member,
  ...system,
  ...stall,
  ...sale,
  ...payment,
  ...statistics,
  ...weixin,
  ...marketing,
  ...merchant,
  ...property,
  ...passengerFlow
}



// WEBPACK FOOTER //
// ./src/api/index.js